import userApi from 'service/user-api';
import { LoggiUser } from 'models/loggi-user.model';

export const fetchLoggiUserUseCase = async companyId => {
  const response = await userApi.getUser(companyId);
  return LoggiUser.parseApiResponse(response);
};
export default { fetchLoggiUserUseCase };
